import React from 'react'
import { RealOrSyntheticEvent } from '@chegg-ui/utils'
import { useRouter } from 'next/router'
import queryString from 'query-string'

import * as Styled from './styled'

interface RouterPaginationProps {
  page: number
  maxPages: number
  setPage: (page: number) => void
}

const RouterPagination: React.FC<RouterPaginationProps> = ({
  page,
  maxPages,
  setPage,
}) => {
  const router = useRouter()
  const parsedQuery = queryString.parse(window.location.search)
  const pageUrls = Array(maxPages)
    .fill('')
    .map((_, i) => {
      const query = {
        ...parsedQuery,
        page: `${i + 1}`,
      }
      return `?${new URLSearchParams(query).toString()}`
    })

  const handleChangePage = (clickedPage: number, e: RealOrSyntheticEvent) => {
    setPage(clickedPage + 1)
    router.push((e as any)?.target?.href, undefined, { shallow: true })
    e.preventDefault()
  }

  return (
    <Styled.Pagination
      pageUrls={pageUrls}
      currentPage={page - 1}
      onChangePage={handleChangePage}
    />
  )
}

export default RouterPagination
